import React, {Component, useEffect, useState} from 'react';
import {NavLink, useHistory, useParams} from 'react-router-dom';
import Logout from "../Auth/Logout";
import { trans } from '../utils';
import logo from '../../assets/img/logo.png';
import axios from 'axios';
import { SystemUrl } from '../../App';
import Template from "../Template";
import config from "../../config.js";
import Notifications from "./Notifications";


const changeLang = (lang) => {

    axios.post(SystemUrl + 'changeLang', { lang: lang }).then(res => {
        if (res.data.status == true) {
            localStorage.setItem('lang', lang);
            localStorage.setItem('styleUrl', urls[lang])
            window.location.reload(false);
        }
    });
    // localStorage.setItem('lang', lang);
    // localStorage.setItem('styleUrl', this.urls[lang])

    // window.location.reload(false);
}
const lang = localStorage.getItem('lang') == 'en' ? 'ar' : 'en';
const urls = { en: "/assets/css/style.bundle.css", ar: '/assets/css/style.bundle.rtl.css' }

const Header = (ComponentToRenderData) => {

    let history = useHistory();
    const routeChange = path => {
        history.push(path);
    }
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const [data, setData ] = useState([]);

    useEffect(() => {
        axios(config.SystemUrl + `Profile/0`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setData(result.data.data));
    }, [])

        return (
            <div id="kt_header" className="header align-items-stretch">

                <div className="container-fluid d-flex align-items-stretch justify-content-between">
                    <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
                        <div className="d-flex align-items-stretch" id="kt_header_nav">
                            <div className="header-menu align-items-stretch" >
                                <div
                                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                                    id="#kt_header_menu" data-kt-menu="true">
                                    <div className="menu-item me-lg-1">
                                        <NavLink className="menu-link py-3" activeClassName='active' to={'/dashboard'}>
                                            <span className="menu-title">{trans('Dashboard')}</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="topbar d-flex align-items-stretch flex-shrink-0">
                            <div className="d-flex align-items-center ms-1 ms-lg-3">
                                <Notifications />
                            </div>

                            <div className="d-flex align-items-center ms-1 ms-lg-3">
                                <ul className="navbar-nav ml-auto nav-flex-icons">
                                    <li className="nav-item avatar dropdown">
                                        <div className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                                             data-toggle="dropdown" aria-haspopup="true"
                                             aria-expanded="true">
                                             <span className="svg-icon svg-icon-1">
                                            <i className="bi bi-person  fs-1"></i>
                                             </span>
                                        </div>
                                        <div className="dropdown-menu dropdown-menu-lg-right dropdown-secondary
                                        menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold fs-6 w-200px"
                                             aria-labelledby="navbarDropdownMenuLink-5">
                                            <div className="menu-item px-3">
                                                <div className="menu-content d-flex align-items-center px-3">
                                                    <div className="symbol symbol-50px me-5">
                                                        <i className="bi bi-people fs-3"></i>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <div className="fw-bolder d-flex align-items-center fs-5">
                                                            {data?.name}
                                                            <span
                                                                className="badge badge-light fw-bolder fs-8 px-2 py-1 ms-2">{data?.type}</span>
                                                        </div>
                                                        <span className="fw-bold text-muted text-primary fs-7">{data?.email}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="separator"></div>
                                            <div className="menu-item">
                                                <a className="menu-link px-5 d-flex "
                                                   data-container="body" onClick={() => {
                                                    let url = "/Profile/View";
                                                    routeChange(url);
                                                }}>
                                                    <span className="symbol symbol-20px me-4">
                                                    <i className="bi bi-gear fs-3"></i>
                                                        </span>
                                                    {trans('Edit Profile')}
                                                </a>
                                            </div>
                                            <div className="separator"></div>
                                            <div className="menu-item">
                                                <a className="menu-link px-5 d-flex " onClick={() => changeLang(lang)}>
                                                    <span className="symbol symbol-20px me-4">
                                                        <i className="bi bi-globe fs-3"></i></span>
                                                    {trans('lang')}
                                                </a>
                                            </div>
                                            <div className="separator"></div>
                                            <div className="menu-item">
                                                <Logout />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        );

}
export default Header
